import type { RouteObject } from 'react-router';
import { LIVE_MAP_PATH } from './live-map.paths';
import { LiveMapPage } from './pages/LiveMapPage';

export const LIVE_MAP_ROUTES: RouteObject[] = [{ path: LIVE_MAP_PATH.slice(1), element: <LiveMapPage /> }];
